import { axios } from '@Root/API'

export const getAll = (contactId, params) => {
	return axios.get(`qualification-award/student-registration/${contactId}`, { params })
}
